<template>
  <v-container fluid class="container-full-bg-gray">
    <app-row>
      <app-col cols="12">
        <app-page-card>
          <template #header>
              Mi plan
          </template>
          <app-container fluid>
          <!-- <app-row v-if="!userData.is_staff" align="center"> -->
          <app-row align="center">
            <app-col cols="3">
              <app-select
                v-model="contract"
                hide-details
                return-object
                label="Contrato"
                item-text="date_name"
                item-value="id"
                :items="contracts"
                @change="setData(contract.id)"
              />
            </app-col>
            <app-col cols="2">
              <app-text-field
                readonly 
                hide-details
                v-if="contract.docs_num"
                label="Documentos contratados" 
                kind="text" 
                :dense="false"
                :value="contract.docs_num.toString()" 
              />
            </app-col>
            <app-col cols="7" class="align-right">
              <v-btn 
                class="no-uppercase"
                color="#613397" 
                @click="csv_download()"
                v-if="asyncJobState === 'done'" 
                indeterminate
              >
                <v-icon left>mdi-download</v-icon>
                <template class="colorText">Descargar CSV</template>
              </v-btn>
            </app-col>
            <!-- <app-col cols="2">
              <date-picker
                v-if="contract.start_date"
                aucomplete="off"
                label="Fecha Inicio" 
                v-model="contract.start_date"
                :readonly="true"
              ></date-picker>
            </app-col>
            <app-col cols="2">
              <date-picker
                v-if="contract.end_date"
                aucomplete="off"
                label="Fecha Final" 
                v-model="contract.end_date"
                :readonly="true"
              ></date-picker>
            </app-col> -->
          </app-row>
          <app-row>
            <app-col cols="12">
              <JobProgress v-model="asyncJobState" :job_id="asyncJobId" v-on:done="jobDone()">
                <template v-slot:progress>
                  <v-progress-circular
                    v-if="asyncJobState==='running'"
                    indeterminate
                    class="mr-2"              
                    color="primary"
                  ></v-progress-circular>
                </template>
                <template v-slot:done>
                  <v-progress-circular
                    v-if="loading"
                    indeterminate
                    class="mr-2"              
                    color="primary"
                  ></v-progress-circular>
                </template>
                <template v-slot:quiet>
                  <dashboard-fast-table v-if="userData.available_features['feature_invoice_state_counter'] && stateCounter" :states="states" :dashboardData="stateCounter" :initialHideDeleted="hideDeleted" @update-hide-deleted="handleHideDeletedChange" @click-dashboard-name="goToDocumentsListNew" @click-dashboard-state="goToDocumentsListNew" :key="stateCounter.toString()"></dashboard-fast-table>
                  <!-- <dashboard-staff-table v-else-if="get_dashboard_data && userData.is_staff" :states="states" :dashboardData="get_dashboard_data.staff_data" :initialHideDeleted="hideDeleted" @update-hide-deleted="handleHideDeletedChange" @click-dashboard-name="setUserLoginas" :key="dashboardData.toString()"></dashboard-staff-table> -->
                  <dashboard-table v-else-if="get_dashboard_data" @update-search-change="handleSearchChange" @update-field-selected="handleFieldChange" @update-hide-deleted="handleHideDeletedChange" :states="states" :dashboardData="items_dashboard_data" :initialHideDeleted="hideDeleted" @click-dashboard-name="goToDocumentsList" @click-dashboard-state="goToDocumentsList" :key="dashboardData.toString()"></dashboard-table>

                </template>
              </JobProgress>
            </app-col>
          </app-row>
          </app-container>
        </app-page-card>
      </app-col>
    </app-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import AppPageCard from '@/components/layout/AppPageCard.vue';
import AppTextField from '@/components/layout/AppTextField.vue';
import AppSelect from '@/components/layout/AppSelect.vue';
import AppContainer from '@/components/layout/AppContainer.vue';
import AppRow from '@/components/layout/AppRow.vue';
import AppCol from '@/components/layout/AppCol.vue';
import DashboardStaffTable from '../components/DashboardStaffTable.vue';
import DashboardTable from '../components/DashboardTable.vue';
import DashboardFastTable from '../components/DashboardFastTable.vue';
import DatePicker from '../components/DatePicker.vue';
import DocTextField from '../components/DocTextField.vue';
import JobProgress from '../components/JobProgress.vue';
import { mapFields } from 'vuex-map-fields';
import { jobs } from '../api/jobs.js';
import { getStateCounterDataApi } from '@/modules/reporting/infrastructure/getStateCounterData';
import { MemoryDataRepository } from '@/modules/reporting/infrastructure/memoryRepositories';
import { BrowserDownloadProvider } from '@/modules/reporting/infrastructure/browserDownloadProvider';
import { CompanyPlan } from "@/modules/reporting/domain/CompanyPlan";
import { DownloadCSV } from '@/modules/reporting/application/DownloadCSV';

export default {
  name: 'DashboardCompanyDB',

  components: {
    AppPageCard,
    AppSelect,
    AppTextField,
    DashboardStaffTable,
    DashboardTable,
    DashboardFastTable,
    DatePicker,
    DocTextField,
    JobProgress,
    AppContainer,
    AppRow,
    AppCol,
  },
  props: {
    username: {
      type: String,
      required: false,
      default: function () {
        return "";
      },
    },
  },
  data() {
    return {
      dashboardData: [],
      states: {},
      contract: {id: 0, date_name: 'Todos los contratos'},
      stateCounter:[],
      asyncJobState: 'done',
      asyncJobId: 0,
      loading: false,
      search: "",
      field_selected: "",
      hideDeleted: true
    }
  },
  computed:{
    ...mapGetters([
      'get_dashboard_data',
      'get_companydbs',
    ]),
    ...mapGetters({
      currentMainFilters: 'documents/currentMainFilters',
      userData: 'me/userData',
      got_feature: 'got_feature',
    }),
    ...mapFields('documents', ['statesFilter', 'selectedStateChip', 'documentListOptions', 'documentListKind']), 
    ...mapFields(['zones', 'dashboard_data']),
    items_dashboard_data() {
      if(this.get_dashboard_data && this.get_dashboard_data.data.length > 0){
        if (this.search === null){
          this.search = ""
        }
        return new CompanyPlan().fillFilteredDomain(this.get_dashboard_data.data, {"search": this.search}, this.field_selected, this.hideDeleted);
      }
    },
    contracts() {
      if(this.userData.available_features['feature_invoice_state_counter']){
        return this.userData.contracts.concat([{id: 0, date_name: 'Todos los contratos'}])
        // return this.userData.contracts
      }
      else{
        return [{id: 0, date_name: 'Todos los contratos'}].concat(this.userData.contracts);
      }
    },
  },
  methods: {
    ...mapActions([
      'setDashboardData',
      'setCurrentCompany',
      'setLoginas',
      'setZones',
      'setProjects',
      'setActivities',
      'setCurrentCompany',
      'refreshData',
      'resetFilters',
    ]),
    ...mapActions({
      refreshUserData: "me/refreshUserData",
      // setCurrentHeaders: "documents/setCurrentHeaders",
      getHeader: "documents/getHeader",
      openPaymentErrorModal: 'payment_error_modal/openModal',
      openPaymentOkModal: 'payment_ok_modal/openModal'
    }),
    goToDocumentsList(dat) {
      if (dat.id && !['deleted', 'deleted_done'].includes(dat.state)) {
        let companydb = null;
        let isCompanyChanged = false;
        for (let i in this.get_companydbs) {
          if (this.get_companydbs[i].id == dat.id) {
            this.selectedStateChip = dat.state;
            this.statesFilter = this.states[dat.state].states;
            this.setCurrentCompany(this.get_companydbs[i]);
            isCompanyChanged = true;
          }
        }
        if (isCompanyChanged) {
          this.setProjects(dat.id);
          this.setActivities(dat.id);
          this.setZones(dat.id);
          // this.setCurrentHeaders();
          this.getHeader();
          this.resetFilters();
          this.$router.push({'name': 'document-list', 'params': { 'companydb_id': dat.id }});
        }
      }
    },
    goToDocumentsListNew(dat) {
      if (dat.id && !['deleted_count', 'booked_deleted_count'].includes(dat.state)) {
        for (let i in this.get_companydbs) {
          if (this.get_companydbs[i].id == dat.id) {
            this.selectedStateChip = dat.state;
            this.statesFilter = this.states[dat.state];
            this.setCurrentCompany(this.get_companydbs[i]);
            this.setProjects(dat.id);
            this.setActivities(dat.id);
            this.setZones(dat.id);
            // this.setCurrentHeaders();
            this.getHeader();
            this.resetFilters();
            this.$router.push({'name': 'document-list', 'params': { 'companydb_id': dat.id }});
          }
        }
      }
    },
    updateDashboardData() {
      this.dashboardData.data = this.items_dashboard_data;
    },
    handleSearchChange(value){
      this.search = value;
    },
    handleFieldChange(value){
      this.field_selected = value
    },
    handleHideDeletedChange(value){
      this.hideDeleted = value
    },
    csv_download() {
      if (!this.get_dashboard_data || !this.get_dashboard_data.data) {
        return;
      }

      let data_repo = new MemoryDataRepository(this.get_dashboard_data ? this.get_dashboard_data.data : []);
      let download_prov = new BrowserDownloadProvider();
      let sreen_data = {"search": this.search};
      let field_selected = this.field_selected
      let cmd = new DownloadCSV(data_repo, download_prov, sreen_data, field_selected);
      cmd.execute();
    },
    setUserLoginas(dat) {
      this.setLoginas(dat.username).then(()=>{
        this.$router.go();
      });
    },
    async setData(contract) {
      if(this.userData.available_features['feature_invoice_state_counter']){
        let res = await getStateCounterDataApi().execute(this.contract.id) //contract
        this.stateCounter = res['state_counters']
        this.states = res['group_states']
        this.loading = false;
      }else{
        this.setDashboardData(contract).then(resp => {
          this.loading = false;
          this.asyncJobId = resp.data['AsyncJob'];
          this.asyncJobState = 'running';
        });
      }
    },
    async jobDone() {
      const response = await jobs.getJob({ id: this.asyncJobId });
      const outputData = response.data && response.data['output_info'] && response.data['output_info']['data'];
      const results = outputData && outputData['results'];
      if (results) {
        this.dashboard_data = results;
        this.states = results['states_values'];
      }
      this.asyncJobState = response.data.state;
    },
  },
  async mounted() {
    this.loading = true;
    if (this.$router.history.current.name == 'payment-error-dashboard') {
      this.openPaymentErrorModal();
    } else if (this.$router.history.current.name == 'payment-ok-dashboard') {
      this.openPaymentOkModal();
    }
    if (this.username) {
      this.setLoginas(this.username).then(()=>{
        this.$router.replace({ 'name': 'dashboard' }, () => {
          this.$router.go();
        });
      });

    } else {    
      await this.refreshUserData();
      this.setData(this.contract.id);
    }
  },
};
</script>

<style scoped>
    .table-head{
        border-left-style:solid;
        border-right-style:solid;
        border-bottom-style:solid;
        border-color:var(--v-primary-base);
        border-width: thin;
    }
    .table-row{
        border-left-style:solid;
        border-right-style:solid;
        border-bottom-style:solid;  
        border-color:var(--v-primary-base);
        border-width: thin;
    }
    .title-color {
        color:var(--v-primary-base);
    }
    .no-uppercase {
      text-transform: none !important;
      margin-right: 30px;
      color: white;
    }
    .align-right {
      display: flex;
      justify-content: flex-end;
    }
    .colorText{
      color: white;
    }

    @media print {

      div.elevation-12 {
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
      }

    }

</style>